import {defineStore} from "pinia";

const defineLocalStorageBackedProperty = (key: string, defaultValue: any) => {
    const actualKey = '_console_' + key;
    const initialValue = localStorage.getItem(actualKey) ?? JSON.stringify(defaultValue);
    const currentValue = ref(JSON.parse(initialValue));
    watch(currentValue, () => {
        localStorage.setItem(actualKey, currentValue.value);
    }, {immediate: true})

    return {
        value: currentValue,
        set: (newValue: any) => {
            currentValue.value = newValue;
        }
    };
}

export const useCustomizerStore = defineStore('customizer', () => {
    const {value: darkMode, set: setDarkMode} = defineLocalStorageBackedProperty('darkMode', false);
    const {value: extraWide, set: setExtraWide} = defineLocalStorageBackedProperty('extraWide', false);

    const actTheme = computed(() => {
        return darkMode.value ? 'DARK_THEME' : 'LIGHT_THEME';
    });

    return {
        darkMode,
        setDarkMode,
        actTheme,
        extraWide,
        setExtraWide,
    }
});
